import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RtSvgSpriteModule } from 'rt-svg-sprite';
import { ConfirmDialogComponent } from '../../../confirm-dialog/confirm-dialog.component';
import { DocStatusDetails, SharedStatusDetailsDialog } from '../../symbols';

/**
 * Default values for confirm dialog component.
 */
const CONFIRM_DIALOG_DEFAULT_VALUES: Required<SharedStatusDetailsDialog> = {
  caption: 'Select status for the document',
  detailsText: '',
  confirm: 'Save',
  cancel: 'Cancel',
  selectedStatus: null,
  availableStatuses: []
};

@Component({
  selector: 'app-shared-manage-status-dialog',
  templateUrl: './shared-manage-status-dialog.component.html',
  styleUrls: ['./shared-manage-status-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatMenu,
    MatMenuItem,
    RtSvgSpriteModule,
    NgStyle,
    MatMenuTrigger,
    MatTooltipModule
  ],
  standalone: true
})
export class SharedManageStatusDialogComponent implements OnInit {
  /** Contain question text. */
  public config: Required<SharedStatusDetailsDialog>;

  /** Contain actual status that should be displayed in the selector. */
  public currentStatus: DocStatusDetails;


  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public injectedData: SharedStatusDetailsDialog,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {
    // Write confirm dialog config as result of merge injected data with default data.
    this.config = Object.assign({}, CONFIRM_DIALOG_DEFAULT_VALUES, injectedData);
  }

  ngOnInit(): void {
    // Assign current status from list of provided.
    this.updateCurrentStatus(this.config.selectedStatus);
  }

  /**
   * Contain logic of changing status.
   */
  public updateCurrentStatus(newStatus: string): void {
    // Find provided status in the list of available statuses.
    this.currentStatus = this.config.availableStatuses.find(availableStatus => newStatus === availableStatus.name);
    if (!this.currentStatus) {
      throw new Error(
        `Status you are trying to select (${newStatus}) is not presented in list of available statuses: ${this.config.availableStatuses.map(
          status => status.name
        )}.`
      );
    }
  }

  /**
   * Close dialog and provide new status data (if need).
   */
  public closeDialog(newStatus?: string): void {
    this.dialogRef.close(newStatus);
  }
}
